import { gql } from '@apollo/client';

export const SWITCH_INIT = gql`
    mutation switchInitProjectValidation($id: Int!) {
        switchInitProjectValidation(id: $id) {
            initProjectValidation
        }
    }
`;
